module.exports = __webpack_public_path__ + "media/images/lock-7a686f25709ecf53dce779d5663aa7b3.svg";